var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Globe_icon",
    "data-name": "Globe icon",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9697",
    "data-name": "Path 9697",
    d: "M12,22A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9698",
    "data-name": "Path 9698",
    d: "M8,3H9A28.424,28.424,0,0,0,9,21H8",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9699",
    "data-name": "Path 9699",
    d: "M15,3a28.424,28.424,0,0,1,0,18",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9700",
    "data-name": "Path 9700",
    d: "M3,16V15a28.424,28.424,0,0,0,18,0v1",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9701",
    "data-name": "Path 9701",
    d: "M3,9A28.424,28.424,0,0,1,21,9",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe_icon.3033f086f55a373603172081caf03104.svg";
export { ForwardRef as ReactComponent };